import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { EvaluationFlow } from "components/EvaluationFlow";
import { EvalIds, GetProductByFilterDocument, RegionType } from "graphql/generated";
import graphQLClient from "graphql/react-query";
import { config } from "src/config";
import { CURRENT_COUNTRY } from "src/constants/Countries";
import { generateAuthorizationHeader } from "src/utils";

interface Props {
  evaluationId: EvalIds;
  productId?: string;
}

export const getServerSideProps: GetServerSideProps = async ({ query, locale, req }) => {
  const { evaluationId, productId = "" } = query;

  const authObj = generateAuthorizationHeader(
    req[config.COOKIES.COOKIES][config.COOKIES.ACCESS_TOKEN]
  );

  try {
    const data = await graphQLClient.request(
      GetProductByFilterDocument,
      {
        input: {
          id: evaluationId as string,
          country: CURRENT_COUNTRY as RegionType
        }
      },
      authObj
    );

    const condition = data?.getProductByFilter?.[0];

    if (condition && condition.requiresEvaluation === false) {
      return {
        redirect: {
          destination: `/orderByCondition/${evaluationId}?productId=${productId}`
        },
        props: {}
      };
    }
  } catch (error) {
    console.log(error);
  }

  return {
    props: {
      ...(await serverSideTranslations(locale)),
      evaluationId,
      productId
    }
  };
};

const EvaluationPage = ({ evaluationId, productId }: Props) => {
  return <EvaluationFlow evaluationId={evaluationId} productId={productId} />;
};

export default EvaluationPage;
